import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import { TypeFileIcon, AddIcon, AttachFileIcon, TrashIcon } from '../../../../images/icons/WrapSvg';
import Task from './Task';

import FileUploader from '../../../inputs/File';
import Snackbar from '../../../labels/Snackbar';

// eslint-disable-next-line
import style from './_styles.css';

/* Helper function */
function download_file(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        save.download = fileName || filename;
        if (
            navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
            navigator.userAgent.search('Chrome') < 0
        ) {
            document.location = save.href;
        } else {
            var evt = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
    } else if (!!window.ActiveXObject && document.execCommand) {
        // for IE < 11
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL);
        _window.close();
    }
}

function parse(json) {
    let result = [];
    if (json) {
        try {
            result = JSON.parse(json);
        } catch (e) {
            console.error(e);
            result = [];
        }
    }
    return result;
}

class File extends React.Component {
    state = {
        files: [],
        isLoading: false,
        autofocus: undefined,
        data: undefined,
        error: undefined,
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.files = data.valor ? parse(data.valor.replace("'", '"')) : [];
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    async getFiles(arr) {
        const { files, data } = this.state;
        const valor = files.concat(arr);
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ isLoading: false, files: valor });
    }

    handleChangeComment = (comment, index) => {
        const { files, data } = this.state;
        const valor = [...files];
        const file = valor[index];
        file.comentario = comment;
        console.log(comment, index);
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ files: valor, autofocus: index });
    };

    handleDelete = (file) => {
        const { files, data } = this.state;
        const valor = [...files];
        const index = valor.indexOf(file);
        valor.splice(index, 1);
        this.props.setValue(data.codigo, JSON.stringify(valor), '', false, {});
        this.setState({ open: false, selected: undefined, files: valor });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, files: [] });
    };

    handleErrorUpload = (error) => {
        this.setState({ isLoading: false, error: error });
    };

    handleDownload = (file) => (event) => {
        event.preventDefault(); // Let's stop this event.
        event.stopPropagation(); // Really this time.
        fetch(`${process.env.REACT_APP_API_FILE}/${file.base}`, {
            method: 'GET',
            headers: {
                Authorization: sessionStorage.token,
                Accept: 'application/json',
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((info) => {
                if (info && info.success) {
                    download_file(
                        `${process.env.REACT_APP_API_FILE}/${file.link}`,
                        info.data.nombre,
                    );
                } else if (info && info.error) {
                    this.setState({ error: info.error });
                }
            })
            .catch((error) => {
                this.setState({ error: error });
            });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    isLoading() {
        this.setState({ isLoading: true });
    }

    component = (data, name, intl, editable, desactivado, parentDeactivated) => {
        const { files, isLoading, autofocus, error } = this.state;
        return (
            <div key={data.codigo} className="flex_full_row wrap margin_right__24">
                {!(!editable || data.disabled || desactivado || parentDeactivated) && (
                    <div className="upload-btn-wrapper margin_top_9">
                        {isLoading && (
                            <CircularProgress size={64} className={'fabProgress64 c_bluish'} />
                        )}
                        <button className="btn bg_ice_blue">
                            <AddIcon width={16} heigth={16} color={'primary'} />
                        </button>
                        <FileUploader
                            multiple={true}
                            onStart={this.isLoading.bind(this)}
                            onDone={this.getFiles.bind(this)}
                            onError={this.handleErrorUpload.bind(this)}
                            instance={this.props.instance}
                            field={data.codigo}
                        />
                    </div>
                )}
                {files.map((f, index) => {
                    const key = name.concat(index);
                    return (
                        <div className="flex_full_row margin_top_9" key={key}>
                            <button className="btn bg_ice_blue" onClick={this.handleDownload(f)}>
                                <AttachFileIcon color="primary" style={{ fontSize: 16 }} />
                            </button>
                            {(!editable || data.disabled) && (
                                <span className="barlow_regular_textwrap c_slate text_align_left">
                                    {f.comentario}
                                </span>
                            )}
                            {!(!editable || data.disabled) && (
                                <div className="flex_full_row elements_from_right">
                                    <TextField
                                        fullWidth
                                        multiline
                                        className="flex_auto_row"
                                        name={'txt-' + key}
                                        id={'txt-' + key}
                                        key={'txt-' + key}
                                        autoFocus={autofocus === index}
                                        label={intl.formatMessage({ id: 'form_field_comment' })}
                                        defaultValue={f.comentario}
                                        onChange={(event) =>
                                            this.handleChangeComment(event.target.value, index)
                                        }
                                    />
                                    {!data.modoTest &&
                                        <TrashIcon
                                            className={'c_bluish margin_top_18 margin_right_18 hand'}
                                            onClick={() => this.handleDelete(f)}
                                        />
                                    }
                                </div>
                            )}
                            {error && (
                                <Snackbar
                                    open={true}
                                    variant="error"
                                    text={error}
                                    nonavbar={true}
                                    onClose={this.handleClose}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    render() {
        const { files, desactivado, parentDeactivated } = this.state;
        const { data, key, last, intl, editable } = this.props;
        return (
            <Task
                key={key}
                data={data}
                desactivado={desactivado || parentDeactivated}
                value={files.length > 0 ? files : undefined}
                icon={<TypeFileIcon color="primary" />}
                text="type_label_file"
                last={last}
                editable={editable}
                allowed
                parentDeactivated={parentDeactivated}
                component={this.component(
                    data,
                    data.codigo,
                    intl,
                    editable,
                    desactivado,
                    parentDeactivated,
                )}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

File.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance.id,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(File));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/File.js